"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var observation_windows_1 = require("../../../common/helpers/observation-windows");
var location_details_html_1 = __importDefault(require("./location-details.html"));
var pickup_location_modal_controller_1 = __importDefault(require("./pickup-location-modal.controller"));
var add_student_modal_html_1 = __importDefault(require("../add-student-modal/add-student-modal.html"));
var add_student_modal_controller_1 = __importDefault(require("../add-student-modal/add-student-modal.controller"));
var cancel_drive_modal_controller_1 = __importDefault(require("../cancel-drive-modal/cancel-drive-modal.controller"));
var cancel_drive_modal_html_1 = __importDefault(require("../cancel-drive-modal/cancel-drive-modal.html"));
var new_custom_pickup_location_modal_html_1 = __importDefault(require("./new-custom-pickup-location-modal.html"));
var new_custom_pickup_location_modal_controller_1 = __importDefault(require("./new-custom-pickup-location-modal.controller"));
var time_2 = require("../../../common/helpers/time");
var AdminDrivesEditController = /** @class */ (function () {
    function AdminDrivesEditController($rootScope, $state, $uibModal, UsersModel, DrivesModel, FlashService, driveSession, AdminEditDriveSessionService, RemindersModel, AdhocLocations, policyData, campuses, sessionTypes, vehicles, instructors, UserService, WaitListModel, schedulingPolicy) {
        var _this = this;
        var _a, _b;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.loading = true;
        this.WaitListModel = WaitListModel;
        this.waitListEnabled = schedulingPolicy.waitListEnabled;
        this.waitListEntries = [];
        this.loadingWaitList = false;
        this.policyData = {
            AllowGradeDuringDrive: policyData.AllowGradeDuringDrive,
            AdhocPickupLocationPolicyData: policyData.AdhocPickupLocationPolicyData,
            UseReportCards: policyData.UseReportCards,
            UseServiceArea: policyData.UseServiceArea,
            StudentsCanBook: policyData.StudentsCanBook,
        };
        this.adhocPickupLocations = AdhocLocations;
        this.reminders = [];
        this.service = AdminEditDriveSessionService;
        this.service.setDriveSession(structuredClone(driveSession));
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleOpenSlotWindowChange =
            this.handleOpenSlotWindowChange.bind(this);
        this.initialLoad = true;
        this.initialDriveSession = structuredClone(driveSession);
        // reference to make two way binding stuff work
        this.driveSession = this.service.state.driveSession;
        // set "saved" property on students so we can remove them or cancel them properly
        if (this.driveSession.observation === false) {
            if (this.driveSession.student) {
                this.driveSession.student.saved = true;
            }
        }
        else {
            if (this.driveSession.students) {
                this.driveSession.students.map(function (student) {
                    student.saved = true;
                    return student;
                });
            }
        }
        this.recomputeEnvelope();
        this.ensureStudentWindows();
        this.sortObservationSlots();
        this.form = this.service.state.form;
        this.rules = this.service.state.rules;
        this.toggleStudentSchoolOverride = false;
        this.$uibModal = $uibModal;
        this.UsersModel = UsersModel;
        this.DrivesModel = DrivesModel;
        this.FlashService = FlashService;
        this.gradingLessonEnabled = this.gradingLessonEnabled.bind(this);
        this.formatDate = this.formatDate.bind(this);
        ////////
        // set instructor
        this.instructors = instructors;
        this.instructors.forEach(function (instructor) {
            if (_this.driveSession.instructor &&
                _this.driveSession.instructor.id === instructor.id) {
                _this.driveSession.instructor = instructor;
            }
        });
        if (!this.driveSession.instructor) {
            this.driveSession.instructor = this.instructors[0];
        }
        // set vehicles
        this.form.vehicles = vehicles;
        this.form.vehicles.forEach(function (vehicle) {
            if (_this.driveSession.vehicle &&
                _this.driveSession.vehicle.id === vehicle.id) {
                _this.driveSession.vehicle = vehicle;
            }
        });
        if (!this.driveSession.vehicle) {
            this.driveSession.vehicle = this.form.vehicles[0];
        }
        // set whether or not drive session allows custom pick up locations
        this.rules.sectorsRequired =
            this.policyData.UseServiceArea.FeatureEnabled &&
                (driveSession.type.allow_custom_pickup_locations === true ||
                    driveSession.type.allow_custom_dropoff_locations === true);
        // set drive session location for the ng-options attribute
        this.form.campuses = campuses;
        if (driveSession.location) {
            var addSessionLocationToSchoolLocations_1 = true;
            this.form.campuses.forEach(function (location) {
                if (location.name === driveSession.location.name) {
                    addSessionLocationToSchoolLocations_1 = false;
                }
            });
            if (addSessionLocationToSchoolLocations_1 === true) {
                this.form.campuses.push(driveSession.location);
            }
        }
        if (this.policyData.UseServiceArea.FeatureEnabled) {
            if (!this.driveSession.location) {
                this.driveSession.location = Object.assign({}, this.form.campuses[0]);
            }
            this.form.campuses.forEach(function (location) {
                if (location.id === _this.driveSession.location.id) {
                    _this.driveSession.location = location;
                }
            });
        }
        if (this.driveSession.student_id) {
            this.adhocPickupLocations.forEach(function (adhoc_location) {
                _this.driveSession.student.pickuplocations.push(adhoc_location);
            });
            this.ensurePickupLocationAvailable();
            // Reconcile pickuplocation reference (same pattern as instructor/vehicle)
            if (this.driveSession.pickuplocation) {
                var matchingPickup = this.driveSession.student.pickuplocations.find(function (loc) { return loc.id === _this.driveSession.pickuplocation.id; });
                if (matchingPickup) {
                    this.driveSession.pickuplocation = matchingPickup;
                }
            }
            else if (this.driveSession.type.allow_custom_pickup_locations === false) {
                this.driveSession.pickuplocation =
                    this.driveSession.student.pickuplocations[0] || this.form.campuses[0];
            }
            // Reconcile dropofflocation reference
            if (this.driveSession.dropofflocation) {
                var matchingDropoff = this.driveSession.student.pickuplocations.find(function (loc) { return loc.id === _this.driveSession.dropofflocation.id; });
                if (matchingDropoff) {
                    this.driveSession.dropofflocation = matchingDropoff;
                }
            }
            else if (this.driveSession.type.allow_custom_dropoff_locations === false) {
                this.driveSession.dropofflocation =
                    this.driveSession.student.pickuplocations[0] || this.form.campuses[0];
            }
            RemindersModel.getReminders(UserService.getCurrentUser().school_id, {
                drive_id: this.driveSession.id,
                student_id: this.driveSession.student_id,
            }).then(function (response) {
                _this.reminders = response.reminders.data;
            });
        }
        // set initial drive session type
        this.form.sessiontypes = sessionTypes.filter(function (type) {
            if (_this.driveSession.type.id === type.id) {
                return type;
            }
            return type.status === "Active";
        });
        this.form.sessiontypes.forEach(function (type) {
            if (type.id === driveSession.type.id) {
                _this.driveSession.type = type;
            }
        });
        if (this.policyData.UseServiceArea.FeatureEnabled) {
            this.form.sectors = [].concat.apply([], (((_a = this.driveSession.location) === null || _a === void 0 ? void 0 : _a.zoneparts) || []));
            this.form.zones = [].concat.apply([], (((_b = this.driveSession.location) === null || _b === void 0 ? void 0 : _b.zones) || []));
            // set the initially selected sectors
            this.form.sectors.forEach(function (locationSector, index) {
                driveSession.zoneparts.forEach(function (driveSector) {
                    if (locationSector.id === driveSector.id) {
                        _this.form.sectors[index].selected = true;
                    }
                });
            });
            // set the initially selected zone
            this.form.zones.forEach(function (zone, index) {
                driveSession.zoneparts.forEach(function (sector) {
                    if (sector.zone_id === zone.id) {
                        _this.form.zones[index].selected = true;
                    }
                });
            });
            this.service.updateSelectAllZonesLabel();
        }
        this.init()
            .then(function (loading) {
            // setup complete
        })
            .catch(function (Error) {
            console.error(Error);
        });
        if (this.waitListEnabled && this.driveSession.type) {
            this.loadWaitListEntries();
        }
    }
    //////////////////////////////////////////////
    AdminDrivesEditController.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                try {
                    this.cancelationRules = {};
                    this.rulesLoadedForStudent = false;
                    if (this.driveSession.student_id) {
                        this.UsersModel.getStudentCancellationRules(this.driveSession.id).then(function (response) {
                            _this.rulesLoadedForStudent = true;
                            _this.cancelationRules = response.data;
                        });
                    }
                    else {
                        this.rulesLoadedForStudent = true;
                    }
                    this.$rootScope.$on("MESSAGE_CLEARED", function () {
                        _this.form.submitted = false;
                    });
                    this.loading = false;
                    return [2 /*return*/, this.loading];
                }
                catch (Error) {
                    console.log(Error);
                    throw Error;
                }
                return [2 /*return*/];
            });
        });
    };
    AdminDrivesEditController.prototype.formatDate = function (dateString) {
        if (!dateString) {
            return "";
        }
        return (0, time_1.formatDateTime)(dateString, "MM/DD/YYYY h:mm a");
    };
    /**
     * Ensures that the student has at least one pickup location available when
     * custom locations are disabled. This prevents empty dropdowns that block
     * form submission for imported students with no saved locations.
     */
    AdminDrivesEditController.prototype.ensurePickupLocationAvailable = function () {
        var _a;
        // Only needed when custom locations are disabled
        if (this.driveSession.type.allow_custom_pickup_locations === true &&
            this.driveSession.type.allow_custom_dropoff_locations === true) {
            return;
        }
        if (!((_a = this.driveSession.student) === null || _a === void 0 ? void 0 : _a.pickuplocations)) {
            return;
        }
        // Get a fallback location: session location or first campus
        var fallbackLocation = this.driveSession.location || this.form.campuses[0];
        if (!fallbackLocation) {
            return;
        }
        // Check if fallback location is already in the list
        var hasLocation = this.driveSession.student.pickuplocations.some(function (loc) { return loc.id === fallbackLocation.id; });
        if (!hasLocation) {
            this.driveSession.student.pickuplocations.unshift(fallbackLocation);
        }
    };
    AdminDrivesEditController.prototype.formatReminderType = function (type) {
        return type.toUpperCase();
    };
    AdminDrivesEditController.prototype.gradingLessonEnabled = function () {
        var durationInMinutes = parseInt(this.driveSession.sessionLengthHours, 10) * 60 +
            parseInt(this.driveSession.sessionLengthMinutes, 10);
        var datestring = (0, time_1.toYMD)(new Date(this.driveSession.drive_date)) +
            " " +
            (0, time_1.formatDateTime)(this.driveSession.start_time, "HH:mm:ss");
        var endTime = (0, time_1.addMinutes)((0, time_1.dateTimeStringToDate)(datestring), durationInMinutes);
        if (this.policyData.AllowGradeDuringDrive.FeatureEnabled === false) {
            // is now after end time
            return endTime < new Date();
        }
        // is now after start time
        return ((0, time_1.dateTimeStringToDate)(this.driveSession.drive_date + " " + this.driveSession.start_time) < new Date());
    };
    AdminDrivesEditController.prototype.currentSessionLength = function () {
        return (parseInt(this.driveSession.sessionLengthHours, 10) * 60 +
            parseInt(this.driveSession.sessionLengthMinutes, 10));
    };
    AdminDrivesEditController.prototype.envelopeStartDate = function () {
        var datePart = this.driveSession.drive_date instanceof Date
            ? (0, time_1.toYMD)(this.driveSession.drive_date)
            : (0, time_1.toYMD)((0, time_2.dateStringToDate)(this.driveSession.drive_date));
        var timePart = this.driveSession.start_time instanceof Date
            ? (0, time_1.formatDateTime)(this.driveSession.start_time, "HH:mm:ss")
            : (0, time_1.formatDateTime)((0, time_2.timeStringToDate)(this.driveSession.start_time), "HH:mm:ss");
        return (0, time_1.dateTimeStringToDate)(datePart + " " + timePart);
    };
    AdminDrivesEditController.prototype.recomputeEnvelope = function () {
        var start = this.envelopeStartDate();
        this.windowEnvelope = {
            start: start,
            end: (0, time_1.addMinutes)(start, this.currentSessionLength()),
        };
    };
    /**
     * Fill in per-student windows for any observation student that doesn't have
     * one yet (legacy data that pre-dates per-student times).
     */
    AdminDrivesEditController.prototype.ensureStudentWindows = function () {
        if (this.driveSession.observation !== true || !this.driveSession.students) {
            return;
        }
        var missing = this.driveSession.students.some(function (student) { return !student.windowStart || !student.windowEnd; });
        if (missing) {
            this.seedEqualSplitWindows();
        }
    };
    /**
     * Pre-fill each student with a sequential, equal slice of the envelope
     * (driver first). Used when toggling observation on or adding a student.
     */
    AdminDrivesEditController.prototype.seedEqualSplitWindows = function () {
        if (!this.driveSession.students) {
            return;
        }
        var windows = (0, observation_windows_1.equalSplitWindows)(this.windowEnvelope.start, this.currentSessionLength(), this.driveSession.students);
        this.driveSession.students.forEach(function (student, index) {
            if (windows[index]) {
                student.windowStart = windows[index].start;
                student.windowEnd = windows[index].end;
                student.windowAdjusted = false;
            }
        });
    };
    /**
     * Append an empty open slot spanning the whole lesson; staff narrow it after.
     */
    AdminDrivesEditController.prototype.addOpenSlot = function () {
        if (!this.driveSession.openSlots) {
            this.driveSession.openSlots = [];
        }
        var existing = this.driveSession.openSlots.map(function (slot) { return ({
            start: slot.windowStart,
            end: slot.windowEnd,
        }); });
        var window = (0, observation_windows_1.nextAvailableWindow)(this.windowEnvelope, existing);
        if (!window) {
            this.FlashService.setMessage({
                type: "error",
                message: "The lesson is fully covered by open slots. Shorten an existing slot to add another.",
            });
            return;
        }
        this.driveSession.openSlots.push({
            windowStart: window.start,
            windowEnd: window.end,
            windowAdjusted: false,
        });
        this.sortObservationSlots();
    };
    AdminDrivesEditController.prototype.removeOpenSlot = function (index) {
        if (!this.driveSession.openSlots) {
            return;
        }
        this.driveSession.openSlots.splice(index, 1);
    };
    /**
     * Keep the booked and open slot lists ordered by start time so the unified
     * Time Slots list reads chronologically. Sorting the source arrays (rather
     * than an orderBy filter) keeps every $index-based binding correct.
     */
    AdminDrivesEditController.prototype.sortObservationSlots = function () {
        this.sortByWindowStart(this.driveSession.students);
        this.sortByWindowStart(this.driveSession.openSlots);
    };
    AdminDrivesEditController.prototype.sortByWindowStart = function (list) {
        if (!Array.isArray(list)) {
            return;
        }
        list.sort(function (first, second) {
            var firstStart = first.windowStart ? first.windowStart.getTime() : 0;
            var secondStart = second.windowStart ? second.windowStart.getTime() : 0;
            return firstStart - secondStart;
        });
    };
    AdminDrivesEditController.prototype.handleOpenSlotWindowChange = function (change) {
        var _a;
        var slot = (_a = this.driveSession.openSlots) === null || _a === void 0 ? void 0 : _a[change.index];
        if (!slot || !change.selected || change.selected.length === 0) {
            return;
        }
        var previousStart = slot.windowStart;
        var previousEnd = slot.windowEnd;
        var timeString = (0, time_1.formatDateTime)(change.selected[0], "HH:mm:ss");
        var chosen = (0, time_1.dateTimeStringToDate)((0, time_1.toYMD)(this.windowEnvelope.start) + " " + timeString);
        var changed = change.name === "openSlotStart" ? "start" : "end";
        if (changed === "start") {
            slot.windowStart = chosen;
        }
        else {
            slot.windowEnd = chosen;
        }
        if (!slot.windowStart || !slot.windowEnd) {
            return;
        }
        var others = this.driveSession.openSlots
            .filter(function (_, index) { return index !== change.index; })
            .map(function (other) { return ({ start: other.windowStart, end: other.windowEnd }); });
        var snapped = (0, observation_windows_1.snapWindowToNeighbors)({ start: slot.windowStart, end: slot.windowEnd }, others, this.windowEnvelope, changed);
        // A non-positive window means the edit landed past a neighbor with no room;
        // reject it and keep the slot where it was.
        if (snapped.end.getTime() <= snapped.start.getTime()) {
            slot.windowStart = previousStart;
            slot.windowEnd = previousEnd;
            slot.windowAdjusted = true;
            return;
        }
        slot.windowStart = snapped.start;
        slot.windowEnd = snapped.end;
        slot.windowAdjusted = snapped.adjusted;
        this.sortObservationSlots();
    };
    /**
     * Pre-fill the open-slot list with one equal slot per seat as a starting point
     * staff can tweak. Reuses equalSplitWindows (role-independent here).
     */
    AdminDrivesEditController.prototype.autoGenerateOpenSlots = function () {
        var _a;
        var seats = ((_a = this.driveSession.vehicle) === null || _a === void 0 ? void 0 : _a.seats) || 0;
        if (seats < 1) {
            return;
        }
        this.recomputeEnvelope();
        var placeholders = Array.from({ length: seats }, function () { return ({}); });
        var windows = (0, observation_windows_1.equalSplitWindows)(this.windowEnvelope.start, this.currentSessionLength(), placeholders);
        this.driveSession.openSlots = windows.map(function (window) { return ({
            windowStart: window.start,
            windowEnd: window.end,
            windowAdjusted: false,
        }); });
    };
    /**
     * Mirror what the API does when the lesson moves or shrinks: shift every
     * window by the same delta, then clamp it back inside the new envelope.
     */
    AdminDrivesEditController.prototype.applyEnvelopeChange = function (oldStart) {
        var _this = this;
        this.recomputeEnvelope();
        if (this.driveSession.observation !== true || !this.driveSession.students) {
            return;
        }
        var delta = oldStart !== null
            ? (0, time_1.differenceInMinutes)(this.windowEnvelope.start, oldStart)
            : 0;
        this.driveSession.students.forEach(function (student) {
            if (!student.windowStart || !student.windowEnd) {
                return;
            }
            var window = {
                start: student.windowStart,
                end: student.windowEnd,
            };
            if (delta !== 0) {
                window = (0, observation_windows_1.shiftWindow)(window, delta);
            }
            var clamped = (0, observation_windows_1.clampWindow)(window.start, window.end, _this.windowEnvelope.start, _this.windowEnvelope.end);
            student.windowStart = clamped.start;
            student.windowEnd = clamped.end;
            student.windowAdjusted = clamped.clamped;
        });
    };
    AdminDrivesEditController.prototype.handleSessionLengthChange = function () {
        this.applyEnvelopeChange(null);
        this.refreshWaitList();
    };
    AdminDrivesEditController.prototype.handleObservationFieldUpdate = function () {
        var _this = this;
        if (this.driveSession.observation === false) {
            delete this.driveSession.openSlots;
            if (this.driveSession.students.length > 0) {
                if (this.driveSession.students.length === 1) {
                    this.driveSession.student = this.driveSession.students[0];
                    this.driveSession.student_id = this.driveSession.students[0].id;
                }
                else {
                    // prompt to cancel for all students in the observation
                    this.driveSession.students.forEach(function (student, index) {
                        _this.cancelSessionModal(student.id, index);
                    });
                }
            }
            delete this.driveSession.students;
            if (this.driveSession.student) {
                this.driveSession.status = "Taken";
            }
            else {
                this.driveSession.status = "Available";
            }
        }
        // this should check the student_id, if observation is true add student_id to .students()
        if (this.driveSession.observation === true) {
            this.recomputeEnvelope();
            if (!this.driveSession.openSlots) {
                this.driveSession.openSlots = [];
            }
            if (this.driveSession.student) {
                if (!this.driveSession.students) {
                    this.driveSession.students = [];
                }
                this.driveSession.students = [].concat(__spreadArray(__spreadArray([], this.driveSession.students, true), [
                    this.driveSession.student,
                ], false));
                delete this.driveSession.student;
                this.driveSession.student_id = null;
                if (this.driveSession.vehicle.seats < this.driveSession.students.length) {
                    this.driveSession.status = "Available";
                }
                else {
                    this.driveSession.status = "Taken";
                }
                this.recomputeEnvelope();
                this.seedEqualSplitWindows();
            }
        }
    };
    AdminDrivesEditController.prototype.selectAllSectors = function () {
        var _this = this;
        this.form.sectors.forEach(function (sector, index) {
            _this.form.sectors[index].selected = true;
        });
        this.form.zones.forEach(function (zone, index) {
            _this.form.zones[index].selected = true;
        });
    };
    AdminDrivesEditController.prototype.updateSessionTypeDefault = function () {
        if (this.driveSession.type.hidden === true) {
            this.driveSession.private = "Y";
        }
        else {
            this.driveSession.private = "N";
        }
        this.rules.sectorsRequired =
            this.driveSession.type.allow_custom_pickup_locations === true ||
                this.driveSession.type.allow_custom_dropoff_locations === true;
        this.refreshWaitList();
    };
    /**
     * Add student modal
     */
    AdminDrivesEditController.prototype.addStudentModal = function (slot) {
        var _this = this;
        if (slot === void 0) { slot = null; }
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: add_student_modal_html_1.default,
            controller: add_student_modal_controller_1.default,
            controllerAs: "vm",
            size: "lg",
            resolve: {
                drivesession: function () { return _this.driveSession; },
                toggleStudentSchoolOverride: function () { return _this.toggleStudentSchoolOverride; },
                preselectedSlot: function () { return slot || null; },
            },
        });
        modalInstance.result.then(function (data) {
            _this.driveSession = data.drivesession;
            if (_this.driveSession.observation === false) {
                _this.adhocPickupLocations.forEach(function (adhoc_location) {
                    data.drivesession.student.pickuplocations.push(adhoc_location);
                });
                _this.ensurePickupLocationAvailable();
                _this.driveSession.student_id = data.drivesession.student.id;
                _this.driveSession.status = "Taken";
            }
            else {
                _this.driveSession.student_id = null;
                _this.driveSession.students = data.drivesession.students;
                if (_this.driveSession.students.length ===
                    _this.driveSession.vehicle.seats) {
                    _this.driveSession.status = "Taken";
                }
                else {
                    _this.driveSession.status = "Available";
                }
                // The student claimed an existing open slot in the modal, so their
                // window is already set; don't re-split the envelope over them.
                _this.sortObservationSlots();
            }
            if (_this.driveSession.type.allow_custom_pickup_locations === false &&
                !_this.driveSession.pickuplocation) {
                _this.driveSession.pickuplocation = _this.driveSession.location;
            }
            if (_this.driveSession.type.allow_custom_dropoff_locations === false &&
                !_this.driveSession.dropofflocation) {
                _this.driveSession.dropofflocation = _this.driveSession.location;
            }
            _this.toggleStudentSchoolOverride = data.toggleStudentSchoolOverride;
        }, function () {
            //$log.info('Modal dismissed at: ' + new Date());
        });
    };
    /**
     * Cancel Session modal
     */
    AdminDrivesEditController.prototype.cancelSessionModal = function (student_id, index) {
        var _this = this;
        if (index === void 0) { index = null; }
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: cancel_drive_modal_html_1.default,
            controller: cancel_drive_modal_controller_1.default,
            controllerAs: "vm",
            size: "lg",
            resolve: {
                drivesession: function () { return _this.driveSession; },
                student_id: function () { return student_id; },
                rules: function () { return _this.cancelationRules; },
            },
        });
        modalInstance.result.then(function (selectedItem) {
            // $scope.selected = selectedItem;
            if (index !== null) {
                _this.removePassenger(index);
                if (_this.service.hasStudents() === false) {
                    _this.driveSession.status = "Available";
                }
            }
            else {
                delete _this.driveSession.student;
                _this.driveSession.student_id = null;
                if (_this.service.hasStudents() === false) {
                    _this.driveSession.status = "Available";
                }
            }
        }, function () { });
    };
    AdminDrivesEditController.prototype.addNewCustomPickupLocation = function (type) {
        var _this = this;
        if (type === void 0) { type = "Pick-up Location"; }
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: new_custom_pickup_location_modal_html_1.default,
            controller: new_custom_pickup_location_modal_controller_1.default,
            controllerAs: "vm",
            size: "md",
            resolve: {
                data: function () {
                    return {
                        locationType: type,
                    };
                },
            },
        });
        modalInstance.result.then(function (selectedItem) {
            _this.driveSession.student.pickuplocations.push(selectedItem);
            if (type === "Pick-up Location") {
                _this.driveSession.pickuplocation =
                    _this.driveSession.student.pickuplocations[_this.driveSession.student.pickuplocations.length - 1];
            }
            else {
                _this.driveSession.dropofflocation =
                    _this.driveSession.student.pickuplocations[_this.driveSession.student.pickuplocations.length - 1];
            }
        }, function () { });
    };
    AdminDrivesEditController.prototype.previewPickupLocation = function (title, location) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: location_details_html_1.default,
            controller: pickup_location_modal_controller_1.default,
            controllerAs: "vm",
            size: "sm",
            resolve: {
                data: {
                    title: title,
                    pickuplocation: location,
                },
            },
        });
        modalInstance.result.then(function (selectedItem) { }, function () { });
    };
    AdminDrivesEditController.prototype.clearForm = function () {
        this.service.resetDriveSession();
        //this.service.resetForm();
        //this.checkSelect();
        // TODO: Avoid manipulating the rules object directly
        this.rules.hasSectors = false;
    };
    AdminDrivesEditController.prototype.checkSelect = function () {
        return this.service.checkSelectedSectors();
    };
    AdminDrivesEditController.prototype.zoneSelected = function (zone) {
        var _this = this;
        this.service.updateSelectAllZonesLabel();
        if (zone.selected === true) {
            // add all sectors of zone
            this.form.sectors.forEach(function (sector, index) {
                if (sector.zone_id === zone.id) {
                    _this.form.sectors[index].selected = true;
                }
            });
        }
        else {
            // remove all sectors of zone
            this.form.sectors.forEach(function (sector, index) {
                if (sector.zone_id === zone.id) {
                    _this.form.sectors[index].selected = false;
                }
            });
        }
    };
    AdminDrivesEditController.prototype.sectorSelected = function (sector) {
        var _this = this;
        if (sector.selected === true) {
            // add the sector's zone
            this.form.zones.forEach(function (zone, index) {
                if (sector.zone_id === zone.id) {
                    _this.form.zones[index].selected = true;
                }
            });
        }
        else {
            // remove the sector's zone
            this.form.zones.forEach(function (zone, index) {
                // are there no selected sectors in this zone?
                var remainingSelectedSectors = _this.form.sectors.filter(function ($sector) {
                    return $sector.zone_id === zone.id && $sector.selected === true;
                });
                // if not deselect the zone
                if (remainingSelectedSectors.length > 0 === false) {
                    _this.form.zones[index].selected = false;
                }
            });
        }
        this.service.updateSelectAllZonesLabel();
        // this.checkSelect();
    };
    AdminDrivesEditController.prototype.resetSessionForm = function () {
        var _a, _b;
        this.form.zones = [].concat.apply([], (((_a = this.driveSession.location) === null || _a === void 0 ? void 0 : _a.zones) || []));
        this.driveSession.zones = [];
        this.form.sectors = [].concat.apply([], (((_b = this.driveSession.location) === null || _b === void 0 ? void 0 : _b.zoneparts) || []));
        if (this.rules.sectorsRequired === false) {
            this.selectAllSectors();
        }
    };
    /**
     * Delete the drive session
     */
    AdminDrivesEditController.prototype.deleteDrive = function () {
        var _this = this;
        if (confirm("Are you sure you want to delete this session?") === false) {
            return;
        }
        this.DrivesModel.deleteDrive(this.driveSession.id).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.$state.go("drivecoach.admin.calendar", {}, { reload: true });
        });
    };
    AdminDrivesEditController.prototype.removePassenger = function (index) {
        if (this.driveSession.observation === false) {
            delete this.driveSession.student;
            this.driveSession.student_id = null;
            this.driveSession.status = "Available";
        }
        else {
            // Return the student's claimed slot to the open pool so it can be booked
            // again.
            var student = this.driveSession.students[index];
            if (student && student.slotId) {
                if (!this.driveSession.openSlots) {
                    this.driveSession.openSlots = [];
                }
                this.driveSession.openSlots.push({
                    id: student.slotId,
                    windowStart: student.windowStart,
                    windowEnd: student.windowEnd,
                    windowAdjusted: false,
                });
            }
            this.driveSession.students.splice(index, 1);
            if (this.driveSession.vehicle.seats !== this.driveSession.students.length) {
                this.driveSession.status = "Available";
            }
            this.sortObservationSlots();
        }
    };
    AdminDrivesEditController.prototype.cleanGeom = function (sector) {
        delete sector.geom;
        return sector;
    };
    AdminDrivesEditController.prototype.goToReportCard = function (studentId) {
        if (this.driveSession.type.reportcardtype.name === "Graded") {
            this.$state.go("drivecoach.admin.createreportcard", {
                driveId: this.driveSession.id,
                studentId: studentId,
            });
        }
        if (this.driveSession.type.reportcardtype.name === "Pass/Fail") {
            this.$state.go("drivecoach.admin.createpassfailreportcard", {
                driveId: this.driveSession.id,
                studentId: studentId,
            });
        }
        if (this.driveSession.type.reportcardtype.name === "Standard") {
            this.$state.go("drivecoach.admin.gradegenericreportcard", {
                driveId: this.driveSession.id,
                studentId: studentId,
            });
        }
    };
    /**
     * Update the drive session
     *
     * @param isValid
     * @returns {boolean}
     */
    AdminDrivesEditController.prototype.updateSession = function (isValid) {
        var _this = this;
        this.form.submitted = true;
        if (isValid) {
            var Session = structuredClone(this.driveSession);
            if (Session.location) {
                Session.overrideLocation =
                    Session.student_id !== null &&
                        Session.location.school_id !== Session.student.school_id;
            }
            else {
                Session.overrideLocation = false;
            }
            if (Session.type.allow_custom_pickup_locations === false &&
                Session.location) {
                Session.pickuplocation = Session.location;
            }
            if (Session.type.allow_custom_dropoff_locations === false &&
                Session.location) {
                Session.dropofflocation = Session.location;
            }
            var hours = parseInt(this.driveSession.sessionLengthHours, 10);
            var minutes = parseInt(this.driveSession.sessionLengthMinutes, 10);
            var start_time = Session.start_time;
            if (start_time instanceof Date) {
                var startTimeDate = Session.start_time;
                Session.formatTime = (0, time_1.formatDateTime)(startTimeDate, "HH:mm:ss");
            }
            else {
                var startTimeDate = (0, time_2.timeStringToDate)(start_time);
                Session.formatTime = (0, time_1.formatDateTime)(startTimeDate, "HH:mm:ss");
            }
            Session.session_length = hours * 60 + minutes;
            if (this.driveSession.drive_date instanceof Date) {
                Session.formatDate = (0, time_1.toYMD)(this.driveSession.drive_date);
            }
            else {
                Session.formatDate = (0, time_1.toYMD)((0, time_2.dateStringToDate)(this.driveSession.drive_date));
            }
            Session.toggleStudentSchoolOverride = this.toggleStudentSchoolOverride;
            Session.sectors = []
                .concat(this.form.sectors)
                .filter(function (sector) { return sector.selected === true; })
                .map(this.cleanGeom);
            // Build the unified `slots` payload from explicit form state: claimed
            // slots come from the booked students, open slots from the slot editor.
            // A final clamp guards any out-of-envelope value. We assemble a fresh
            // array rather than mutate the cloned domain collection in place.
            if (Session.observation === true) {
                var toWireWindow_1 = function (start, end) {
                    var clamped = (0, observation_windows_1.clampWindow)(start || _this.windowEnvelope.start, end || _this.windowEnvelope.end, _this.windowEnvelope.start, _this.windowEnvelope.end);
                    return (0, observation_windows_1.formatPivotWindow)({ start: clamped.start, end: clamped.end });
                };
                var claimedSlots = (Session.students || []).map(function (student) {
                    var window = toWireWindow_1(student.windowStart, student.windowEnd);
                    var slot = {
                        student_id: student.id,
                        observer_or_driver: student.observer_or_driver,
                        start: window.start,
                        end: window.end,
                    };
                    if (student.slotId) {
                        slot.id = student.slotId;
                    }
                    return slot;
                });
                var openSlots = (Session.openSlots || []).map(function (slot) {
                    var window = toWireWindow_1(slot.windowStart, slot.windowEnd);
                    var payload = { start: window.start, end: window.end };
                    if (slot.id) {
                        payload.id = slot.id;
                    }
                    return payload;
                });
                Session.slots = claimedSlots.concat(openSlots);
            }
            delete Session.students;
            delete Session.openSlots;
            delete Session.sessionLengthHours;
            delete Session.sessionLengthMinutes;
            delete Session.plots;
            if (Session.instructor.id === 0) {
                delete Session.instructor;
            }
            if (Session.vehicle.id === 0) {
                delete Session.vehicle;
            }
            // lighten the payload a bit
            if (Session.hasOwnProperty("student") && Session.student) {
                if (Session.student.hasOwnProperty("pickuplocations") &&
                    Session.student.pickuplocations) {
                    Session.student.pickuplocations = Session.student.pickuplocations.map(function (location) {
                        if (location.hasOwnProperty("zoneparts")) {
                            // TODO: Remove this when I have a map endpoint
                            location.zoneparts = location.zoneparts.map(_this.cleanGeom);
                        }
                        return location;
                    });
                }
            }
            if (Session.hasOwnProperty("location") && Session.location) {
                if (Session.location.hasOwnProperty("zones") &&
                    Session.location.zones) {
                    Session.location.zones = Session.location.zones.map(function (zone) {
                        if (zone.hasOwnProperty("zoneparts")) {
                            // TODO: Remove this when I have a map endpoint
                            zone.zoneparts = zone.zoneparts.map(_this.cleanGeom);
                        }
                        return zone;
                    });
                }
            }
            if (this.policyData.UseServiceArea.FeatureEnabled === false) {
                delete Session.location;
                delete Session.zones;
                delete Session.zoneparts;
            }
            this.DrivesModel.updateDrive(Session)
                .then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.form.submitted = false;
                _this.$state.go("drivecoach.admin.calendar", {}, { reload: true });
            })
                .catch(function (error) {
                _this.form.submitted = false;
            });
        }
        else {
            this.form.submitted = false;
            this.FlashService.setMessage({
                type: "error",
                message: "Please fill the form.",
            });
        }
    };
    AdminDrivesEditController.prototype.formatDuration = function (minutes) {
        return (0, time_1.formatDuration)(minutes);
    };
    AdminDrivesEditController.prototype.isLocationOutsideSelectedSectors = function (location) {
        if (!location || !location.zoneparts || !this.form.sectors) {
            return false;
        }
        var selectedSectorIds = this.form.sectors
            .filter(function (sector) { return sector.selected === true; })
            .map(function (sector) { return sector.id; });
        if (selectedSectorIds.length === 0) {
            return false;
        }
        return !location.zoneparts.some(function (zonepart) {
            return selectedSectorIds.includes(zonepart.id);
        });
    };
    AdminDrivesEditController.prototype.customPickupLocationDisallowed = function () {
        var _a;
        return this.customLocationDisallowed((_a = this.driveSession.type) === null || _a === void 0 ? void 0 : _a.allow_custom_pickup_locations, this.driveSession.pickuplocation);
    };
    AdminDrivesEditController.prototype.customDropoffLocationDisallowed = function () {
        var _a;
        return this.customLocationDisallowed((_a = this.driveSession.type) === null || _a === void 0 ? void 0 : _a.allow_custom_dropoff_locations, this.driveSession.dropofflocation);
    };
    AdminDrivesEditController.prototype.customLocationDisallowed = function (allowCustomLocations, selectedLocation) {
        if (allowCustomLocations !== false) {
            return false;
        }
        if (!selectedLocation || !this.driveSession.location) {
            return false;
        }
        return selectedLocation.id !== this.driveSession.location.id;
    };
    AdminDrivesEditController.prototype.handleDateChange = function (newDate) {
        var oldStart = this.windowEnvelope ? this.windowEnvelope.start : null;
        this.service.updateSessionDate(newDate);
        this.applyEnvelopeChange(oldStart);
        this.refreshWaitList();
    };
    AdminDrivesEditController.prototype.handleTimeChange = function (newTime) {
        var oldStart = this.windowEnvelope ? this.windowEnvelope.start : null;
        this.service.updateSessionTime(newTime);
        this.applyEnvelopeChange(oldStart);
        this.refreshWaitList();
    };
    AdminDrivesEditController.prototype.loadWaitListEntries = function () {
        var _this = this;
        if (!this.driveSession.type || !this.driveSession.drive_date) {
            this.waitListEntries = [];
            return;
        }
        this.loadingWaitList = true;
        var sessionLength = parseInt(this.driveSession.sessionLengthHours, 10) * 60 +
            parseInt(this.driveSession.sessionLengthMinutes, 10);
        var dateStr;
        if (this.driveSession.drive_date instanceof Date) {
            dateStr = (0, time_1.formatDateTime)(this.driveSession.drive_date, "YYYY-MM-DD");
        }
        else {
            dateStr = (0, time_1.formatDateTime)((0, time_2.dateStringToDate)(this.driveSession.drive_date), "YYYY-MM-DD");
        }
        var timeStr;
        if (this.driveSession.start_time instanceof Date) {
            timeStr = (0, time_1.formatDateTime)(this.driveSession.start_time, "HH:mm");
        }
        else {
            timeStr = (0, time_1.formatDateTime)((0, time_2.timeStringToDate)(this.driveSession.start_time), "HH:mm");
        }
        this.WaitListModel.getAvailable({
            date: dateStr,
            time: timeStr,
            wait_listable_type: "session_type",
            wait_listable_id: this.driveSession.type.id,
            minutes: sessionLength,
        })
            .then(function (response) {
            _this.waitListEntries = response.waitLists;
            _this.loadingWaitList = false;
        })
            .catch(function (error) {
            if (error.status === 403) {
                _this.waitListEnabled = false;
            }
            _this.waitListEntries = [];
            _this.loadingWaitList = false;
        });
    };
    AdminDrivesEditController.prototype.refreshWaitList = function () {
        if (this.waitListEnabled) {
            this.loadWaitListEntries();
        }
    };
    AdminDrivesEditController.prototype.selectFromWaitlist = function (entry) {
        var _this = this;
        this.UsersModel.getPickupLocations(entry.user_id).then(function (response) {
            var student = {
                id: entry.user.id,
                firstname: entry.user.firstname,
                lastname: entry.user.lastname,
                fullname: entry.user.fullname,
                pickuplocations: response.pickuplocations,
                saved: false,
            };
            if (_this.driveSession.observation === false) {
                _this.driveSession.student = student;
                _this.driveSession.student_id = student.id;
                _this.driveSession.status = "Taken";
                _this.ensurePickupLocationAvailable();
                if (_this.driveSession.type.allow_custom_pickup_locations === false &&
                    !_this.driveSession.pickuplocation) {
                    _this.driveSession.pickuplocation = _this.driveSession.location;
                }
                if (_this.driveSession.type.allow_custom_dropoff_locations === false &&
                    !_this.driveSession.dropofflocation) {
                    _this.driveSession.dropofflocation = _this.driveSession.location;
                }
            }
        });
    };
    return AdminDrivesEditController;
}());
AdminDrivesEditController.$inject = [
    "$rootScope",
    "$state",
    "$uibModal",
    "UsersModel",
    "DrivesModel",
    "FlashService",
    "driveSession",
    "AdminEditDriveSessionService",
    "RemindersModel",
    "AdhocLocations",
    "policyData",
    "campuses",
    "sessionTypes",
    "vehicles",
    "instructors",
    "UserService",
    "WaitListModel",
    "schedulingPolicy",
];
exports.default = AdminDrivesEditController;
